import { cn } from '@hbs-us/ui';
import { forwardRef, type InputHTMLAttributes } from 'react';

/**
 * Text input primitive (shadcn copy-in, token-only). 44px tall (A11Y-01 target
 * floor), visible orange focus ring (`--ring`). Always paired with a <label> in
 * the room — the primitive carries no hardcoded copy or color.
 */
export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...props }, ref) {
    return (
      <input
        ref={ref}
        className={cn(
          'h-11 w-full rounded-md border border-input bg-background px-3 text-foreground text-sm',
          'placeholder:text-muted-foreground',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      />
    );
  },
);
